import {useQueries} from "@tanstack/react-query";
import ocrIndicatorService from "../../../../../services/web/ocr-indicator-service.js";
import nocService from "../../../../../services/web/noc-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['lanes'],
                queryFn: () => ocrIndicatorService.getAllToSelect(),
                initialData: []
            },
            {
                queryKey: ['archiver'],
                queryFn: () => nocService.getAllArchiversFilter(),
                initialData: []
            }
        ]
    });

    return {
        lanesOptions: queries[0].data,
        archiverOptions: queries[1].data
    }
}

export default UseFetchOptions;